import React, { useEffect, useState } from 'react';
import { Checkbox, Divider, Form, FormInstance } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import cx from 'classnames';
import { useDataUnitTypeSelect } from '../../hooks';
import {
    apiMessagesGetFormRules,
    apiMessagesGetFormRulesFieldBlank,
    rulesIsNumber,
    rulesMoreThanZero,
} from '../../middleware';
import { toNum } from '../../instruments';
import { ITrField, tB, tF } from '../../translate';
import { Catcher, FormSelect, InputNumberDebounce } from '../../Components';
import Styles from '../styles/m_itemCardStyles.less';

type ILimitUnitSelector = {
    disabled: boolean;
    onSelect?: (value: string) => void;
    unitFieldName: string;
};

export const LimitUnitSelector: React.FC<ILimitUnitSelector> = ({
    disabled,
    onSelect,
    unitFieldName,
}: ILimitUnitSelector) => {
    const onChange = (value: string | Array<string>) => {
        onSelect && onSelect(typeof value === 'string' ? value : value[0]);
    };
    return (
        <FormSelect
            dataTest={'EditUsageLimitUnit'}
            disabled={disabled}
            fieldName={unitFieldName}
            idSpinners={['GET_DATA_UNIT_TYPE_SELECT']}
            isAddonAfter={true}
            isNotClear={true}
            rules={apiMessagesGetFormRules}
            useSelectHook={useDataUnitTypeSelect}
            onChange={onChange}
        />
    );
};

type IInitValues = { limit?: number; unit?: string };

type IFieldUsageLimitProps = {
    fields: { limit: string; unit: string };
    form: FormInstance;
    initialValues: any;
    label: ITrField;
    setForm?: (values: any) => void;
};

export const FieldDataVolumeUnit: React.FC<IFieldUsageLimitProps> = ({
    fields: { limit, unit },
    form,
    initialValues,
    label,
    setForm,
}: IFieldUsageLimitProps) => {
    const [isEnabled, setIsEnabled] = useState<boolean>(false);
    const [initValues, setIsInitValues] = useState<IInitValues>({ limit: undefined, unit: undefined });

    useEffect(() => {
        if (!initValues.unit && !!initialValues[unit]) {
            setIsInitValues({ limit: initialValues[limit], unit: initialValues[unit] });
            if (initialValues[limit] !== undefined) {
                setIsEnabled(true);
            }
        }
    }, [initialValues[unit]]);

    const setManualEnabled = (e: CheckboxChangeEvent) => {
        if (e.target.checked) {
            const values = {
                [limit]: initValues.limit,
                [unit]: initValues.unit || 'b',
            };
            form.setFieldsValue(values);
            setForm && setForm({ ...initialValues, ...values });
            setIsEnabled(true);
        } else {
            const values = {
                [limit]: undefined,
                [unit]: 'b',
            };
            form.setFieldsValue(values);
            setForm && setForm({ ...initialValues, ...values });
            setIsEnabled(false);
        }
    };
    const saveLimit = (value: string | number | undefined | null) => {
        const numValue = toNum(value);
        setForm && setForm({ ...initialValues, [limit]: numValue });
    };
    const saveUnit = (value: string) => {
        setForm && setForm({ ...initialValues, [unit]: value });
    };

    return (
        <Catcher>
            <Checkbox onChange={setManualEnabled} checked={isEnabled} className={cx(Styles.cardCleanField)}>
                {`${tB('Enabled')} - ${tF(label)}`}
            </Checkbox>
            <Form.Item
                name={limit}
                label={tF(label)}
                rules={
                    isEnabled ? [...apiMessagesGetFormRulesFieldBlank(), rulesIsNumber, rulesMoreThanZero] : undefined
                }
                className={cx({ [Styles.hideElement]: !isEnabled })}
            >
                <InputNumberDebounce
                    disabled={!isEnabled}
                    placeholder={tF(label)}
                    min={1}
                    step={1}
                    onChange={saveLimit}
                    addonAfter={<LimitUnitSelector disabled={!isEnabled} unitFieldName={unit} onSelect={saveUnit} />}
                />
            </Form.Item>
            <Divider key={`d-${limit}`} />
        </Catcher>
    );
};
